// extracted by css-extract-rspack-plugin
export default {"root":"root-dt4FY5","label":"label-MTykH0","collapse":"collapse-c4UzZu"};